import { render, staticRenderFns } from "./PortalAccordionItem.vue?vue&type=template&id=279ce598&"
import script from "./PortalAccordionItem.vue?vue&type=script&lang=ts&"
export * from "./PortalAccordionItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports